// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:44:27

export default {
  "id": "bubble-shooter-panda-blast",
  "slug": "bubble-shooter-panda-blast",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/ec26299f47ed455e9d1468c5914883ae-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/ec26299f47ed455e9d1468c5914883ae/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Bubble Shooter Panda Blast",
      "description": "Step into the colorful world of Panda Blast, where your mission is to rescue baby pandas by popping bubbles. Mama Panda needs your help to bring her lost cubs home. With vibrant graphics, charming animations, and exciting puzzles, this game is perfect for all ages.\nMatch three or more bubbles to clear them, free trapped pandas, and progress through hundreds of fun levels. Use powerful boosters, enjoy daily rewards, and experience smooth animations that bring the adventure to life.",
      "instructions": "Match three or more bubbles to pop them.\nAim carefully and shoot to rescue baby pandas.\nUse boosters to clear levels faster.\nCollect coins and unlock new challenges.",
      "genres": [
        "Bubble Shooter"
      ],
      "tags": [
        "bubble",
        "color",
        "colormatch",
        "panda"
      ]
    },
    "zh-CN": {
      "title": "泡泡射手熊猫爆破",
      "description": "踏入五彩斑斓的熊猫爆破世界，你的任务是通过戳破泡泡来营救小熊猫。熊猫妈妈需要你的帮助来找回她丢失的孩子们。游戏拥有鲜艳的图形、迷人的动画和激动人心的谜题，适合所有年龄段的玩家。\n匹配三个或更多的泡泡来清除它们，解救被困的熊猫，并闯过数百个有趣的关卡。使用强大的助推器，享受每日奖励，并体验流畅的动画，让冒险生动呈现。",
      "instructions": "匹配三个或更多气泡以爆破它们。\n仔细瞄准并射击以拯救小熊猫。\n使用增强器更快地通过关卡。\n收集硬币并解锁新挑战。",
      "genres": [
        "泡泡龙"
      ],
      "tags": [
        "泡泡",
        "颜色",
        "颜色匹配",
        "熊猫"
      ]
    },
    "zh-TW": {
      "title": "泡泡射手熊猫炸彈",
      "description": "進入五彩繽紛的「熊猫爆破」世界，你的任務是通過爆破氣泡來救出小熊貓。母熊貓需要你的幫助將失散的小寶貝帶回家。這款遊戲擁有生動的圖像、迷人的動畫和刺激的謎題，適合所有年齡層的玩家。\n\n匹配三個或更多氣泡來清除它們，釋放被困的熊貓，並進行百餘個有趣關卡。使用強力加強劑，享受每日獎勵，並體驗將冒險變得生動的流暢動畫。",
      "instructions": "連結三個或以上的泡泡以泡泡破裂。\n精心瞄准並射擊以拯救小寶寶熊。\n使用強化器以更快地清關。\n收集硬幣並解鎖新挑戰。",
      "genres": [
        "泡泡射手"
      ],
      "tags": [
        "泡泡",
        "顏色",
        "顏色匹配",
        "熊貓"
      ]
    },
    "zh-HK": {
      "title": "泡泡射擊熊貓炸彈",
      "description": "步進充滿色彩的Panda Blast世界，你的任務是透過爆破泡泡來拯救小熊貓。母熊貓需要你的幫助將失散的小熊貓帶回家。這款遊戲擁有生動的圖像、迷人的動畫和刺激的謎題，適合各個年齡層。匹配三個或以上的泡泡來消除它們，釋放被困的熊貓，並通過數百個有趣的關卡。使用強大的加強器，享受每日獎勵，並體驗讓冒險活躍起來的順暢動畫。",
      "instructions": "連續匹配三個或以上的泡泡以將其爆破。\n仔細瞄准並射擊以拯救小寶寶熊。\n使用加強器以更快地通過關卡。\n收集硬幣以解鎖新挑戰。",
      "genres": [
        "泡泡砲"
      ],
      "tags": [
        "泡泡",
        "色彩",
        "色彩匹配",
        "熊貓"
      ]
    },
    "ja": {
      "title": "バブルシューターパンダブラスト",
      "description": "パンダブラストのカラフルな世界へ足を踏み入れて、バブルをパoppingして赤ん坊のパンダを救出する使命を果たしましょう。ママパンダはあなたの助けが必要で、失われた赤ん坊を故郷に連れ戻すためにいます。鮮やかなグラフィック、魅力的なアニメーション、楽しいパズルで、全ての年齢層に適しています。\n\n三つ以上のバブルをマッチして消して、捕らわれたパンダを解放し、数百の楽しいレベルを進んでいきましょう。強力なブースターを使い、毎日の報酬を楽しみ、冒険を生き生きと演出する滑らかで魅力的なアニメーションを体験してください。",
      "instructions": "３つ以上の泡を連結して爆破します。\n慎重に狙い、赤ん坊のパンダを救出します。\nブースターを使ってレベルを速くクリアします。\nコインを集め、新しい挑戦を解禁します。",
      "genres": [
        "バブルシューター"
      ],
      "tags": [
        "泡",
        "色",
        "色合わせ",
        "パンダ"
      ]
    },
    "ko": {
      "title": "발포쇼터 판다 블랙스트",
      "description": "팬더 blast의 다채로운 세계에 들어가어, 퍼브를 터뜨려 새끼 팬더를 구출하는 임무를 수행하세요. 엄마 팬더는 잃어버린 조손들을 집으로 돌아가게 도와달라고 합니다. 생동감 넘치는 그래픽, 매력적인 애니메이션, 흥미진진한 퍼즐로 모든 연령대에게 적합한 이 게임입니다.\n세 개 이상의 퍼브를 일치시켜 제거하고, 구금된 팬더를 풀어서 수많은 재미있는 레벨을 통과하세요. 강력한 보스터를 사용하고, 매일 보상을 즐기며 모험을 더욱 생동감 있게 만드는 원활한 애니메이션을 경험하세요.",
      "instructions": "사람들 세 개 이상의 연못을 맞춰 터뜨려라.\n주의 깊게 발사하고 어린 펭귄을 구하려고 노력해라.\n보스터를 사용하여 레벨을 더 빨리 정리하려고.\n코인을 모아 새로운 도전 과제를 해금하라.",
      "genres": [
        "폭스팅 셔터"
      ],
      "tags": [
        "버블",
        "색상",
        "색상매칭",
        "판다"
      ]
    },
    "fr": {
      "title": "Tir à Bulles Panda Blast",
      "description": "Plongez dans le monde coloré de Panda Blast, où votre mission est de sauver les bébés pandas en éclatant des bulles. La maman panda a besoin de votre aide pour ramener ses petits chez elle. Avec des graphismes vibrants, des animations charmantes et des puzzles captivants, ce jeu est parfait pour tous les âges.\n\nFaites correspondre trois bulles ou plus pour les éclater, libérez les pandas coincés et progressez à travers des centaines de niveaux amusants. Utilisez des boosters puissants, profitez des récompenses quotidiennes et vivez des animations fluides qui rendent l'aventure vivante.",
      "instructions": "Formez trois bulles ou plus pour les éclater.\nVissez bien et tirez pour sauver les pandas bébés.\nUtilisez les boosters pour passer les niveaux plus vite.\nCollectez des pièces et débloquez de nouveaux défis.",
      "genres": [
        "Tire-Bulle"
      ],
      "tags": [
        "bulle",
        "couleur",
        "colormatch",
        "panda"
      ]
    }
  }
};
